import { z } from "zod";

import { DatabaseIdentity } from "@/core/api";
import { DateIsoString } from "@/core/types";
import { Attachment } from "@/data/attachments";
import { ConsultantProfile } from "@/data/consultant-profiles/types/ConsultantProfile";
import { WorkStyle } from "@/data/consultant-profiles/types/WorkStyle";
import { JobApplicationComment } from "@/data/job-applications/types/JobApplicationComment";
import { JobApplicationCostsDto } from "@/data/job-applications/types/JobApplicationCostsDto";
import { JobApplicationRate } from "@/data/job-applications/types/JobApplicationRate";
import { JobApplicationStatus } from "@/data/job-applications/types/JobApplicationStatus";
import { JobRequest } from "@/data/job-requests/types/JobRequest";
import { PayexpressJobRequestApplicationDto } from "@/data/payexpress/types/PayexpressJobRequestApplicationDto";
import { Answer } from "@/data/questionnaire/types/Answer";
import { RelatedEntities } from "@/data/related";

import { JobApplicationStepKey } from "./JobApplicationStepKey";

export const JobApplication = z
  .object({
    jobRequest: JobRequest,
    consultantProfile: ConsultantProfile,
    status: JobApplicationStatus,

    comment: JobApplicationComment.nullish(),

    motivation: z.string().nullable(),
    rate: JobApplicationRate.nullable(),

    createdDate: DateIsoString,
    modifiedDate: DateIsoString,
    submittedDate: DateIsoString.nullable(),

    submittedByDto: ConsultantProfile.nullish(),

    answers: z.array(Answer),
    attachments: z.array(Attachment),

    relatedEntities: RelatedEntities.nullish(),
    workStyles: z.array(WorkStyle).nullish(),

    step: JobApplicationStepKey.nullish(),

    updateCvs: z.boolean().optional(),
    updateAvailability: z.boolean().optional(),
    updateWorkstyles: z.boolean().optional(),
    updateContactPersonPhoneNumber: z.boolean().optional(),

    payExpressSelected: z.boolean().nullish(),
    costs: JobApplicationCostsDto.nullish(),
    payExpress: PayexpressJobRequestApplicationDto.nullish(),
  })
  .merge(DatabaseIdentity)
  .passthrough();

export type JobApplication = z.infer<typeof JobApplication>;
